import { render } from "./checkout-area.vue?vue&type=template&id=391a63d2&scoped=true"
import script from "./checkout-area.vue?vue&type=script&lang=js"
export * from "./checkout-area.vue?vue&type=script&lang=js"

import "./checkout-area.vue?vue&type=style&index=0&id=391a63d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391a63d2"]])

export default __exports__